module.exports = __webpack_public_path__ + "media/images/G-01-18ed20df4712b046df7f113dcd63755e.svg";